export const ja = {
  // Common
  common: {
    loading: '読み込み中...',
    error: 'エラー',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    add: '追加',
    search: '検索',
    back: '戻る',
    close: '閉じる',
    confirm: '確認',
    yes: 'はい',
    no: 'いいえ',
    ok: 'OK',
    submit: '送信',
    reset: 'リセット',
    clear: 'クリア',
    view: '表示',
    details: '詳細',
    settings: '設定',
    logout: 'ログアウト',
    login: 'ログイン',
    signup: 'サインアップ',
    profile: 'プロフィール',
    collection: 'コレクション',
    insights: 'インサイト',
    overview: '概要',
    categories: 'カテゴリ',
    preorders: '予約注文',
    recent: '最近',
    total: '合計',
    average: '平均',
    price: '価格',
    quantity: '数量',
    brand: 'ブランド',
    series: 'シリーズ',
    type: 'タイプ',
    scale: 'スケール',
    source: 'ソース',
    date: '日付',
    status: 'ステータス',
    value: '価値',
    items: 'アイテム',
    owned: '所有',
    preorder: '予約注文',
    created: '作成日',
    updated: '更新日',
    name: '名前',
    code: 'コード',
    description: '説明',
    image: '画像',
    currency: '通貨',
    language: '言語',
    preferences: '設定',
    clone: '複製',
    cloneSuccess: 'おもちゃが正常に複製されました',
    cloneError: 'おもちゃの複製に失敗しました',
    backToCollection: 'コレクションに戻る'
  },

  // Navigation
  nav: {
    home: 'ホーム',
    collection: 'コレクション',
    insights: 'インサイト',
    wishlist: 'ウィッシュリスト',
    settings: '設定',
    profile: 'プロフィール',
    logout: 'ログアウト',
    language: '言語',
    export: 'エクスポート'
  },

  // Landing Page
  landing: {
    title: 'ToyPort',
    subtitle: '究極のおもちゃコレクション管理ツール',
    description: 'おもちゃやモデルのコレクションを簡単に整理、追跡、管理できます。コレクターによって、コレクターのために作られました。',
    getStarted: '始める',
    signUp: 'サインアップ',
    goToCollection: 'コレクションへ',
    sampleCollection: 'サンプルコレクション',
    features: {
      title: '強力な機能',
      subtitle: 'コレクション管理に必要なすべて',
      completeManagement: {
        title: '完全な管理',
        description: '詳細な情報とカテゴリでおもちゃを追加、編集、整理します。'
      },
      smartSearch: {
        title: 'スマート検索',
        description: '強力な検索とフィルタリング機能でおもちゃを素早く見つけます。'
      },
      multiCurrency: {
        title: 'マルチ通貨',
        description: '自動変換サポートでローカル通貨での価格を追跡します。'
      },
      preorderTracking: {
        title: '予約追跡',
        description: '予約とその予想リリース日を追跡します。'
      },
      cloudSync: {
        title: 'クラウド同期',
        description: 'コレクションはすべてのデバイスで自動的に同期されます。'
      },
      secure: {
        title: '安全でプライベート',
        description: 'データは暗号化され、プライベートです。あなただけがコレクションにアクセスできます。'
      }
    },
    howItWorks: {
      title: '使い方',
      subtitle: 'シンプルな4ステッププロセスで数分で始められます',
      signUp: {
        title: 'サインアップ',
        description: 'メールまたはソーシャルログインで数秒で無料アカウントを作成します。'
      },
      addToys: {
        title: 'おもちゃを追加',
        description: '使いやすいインターフェースで既存のコレクションを追加します。'
      },
      organize: {
        title: '整理',
        description: '簡単な管理のためにコレクションを分類し、タグ付けします。'
      },
      monitor: {
        title: '監視と追跡',
        description: 'コレクションの価値を追跡し、おもちゃについての洞察を得ます。'
      }
    },
    benefits: {
      title: 'なぜToyPortを選ぶのか？',
      subtitle: 'コレクション管理にToyPortを信頼する何千人ものコレクターに参加してください',
      neverLose: 'コレクションを見失うことはありません',
      trackValue: 'コレクションの総価値を追跡',
      planPurchases: '価格追跡で将来の購入を計画',
      shareCollection: '友達や家族とコレクションを共有',
      mobileFriendly: '任意のデバイスからコレクションにアクセス',
      freeToUse: '隠れたコストなしで完全に無料'
    },
    collectorTypes: {
      title: 'すべてのコレクターに最適',
      description: 'ガンプラ、スケールモデル、アクションフィギュア、またはその他のおもちゃを収集するかどうかにかかわらず、ToyPortがサポートします。',
      startCollection: 'コレクションを始める'
    },
    cta: {
      title: 'コレクションの整理を準備しましたか？',
      subtitle: 'すでにToyPortでコレクションを整理している何千人ものコレクターに参加してください。',
      createAccount: '無料アカウントを作成'
    }
  },

  // Collection
  collection: {
    title: 'マイおもちゃコレクション',
    addNewToy: '新しいおもちゃを追加',
    searchPlaceholder: '名前、コード、ブランド、またはシリーズで検索...',
    noToys: 'コレクションにおもちゃがまだありません。',
    noSearchResults: '検索に一致するおもちゃが見つかりません。',
    addFirstToy: '最初のおもちゃを追加',
    showingResults: '{total}個中{count}個を表示',
    endOfResults: 'コレクションの最後に到達しました',
    viewDetailedInsights: '詳細インサイトを表示',
    summary: {
      title: '大切なおもちゃコレクションを追跡・整理',
      totalToys: '総おもちゃ数',
      foundToys: '見つかったおもちゃ',
      totalValue: '総価値',
      averagePrice: '平均価格',
      totalQuantity: '総数量'
    },
    share: {
      description: 'Share a view-only link of your collection with friends or buyers.',
      copyLink: 'Copy public link',
      preview: 'Preview public page',
      copied: 'Public link copied to your clipboard.',
      copyFailed: 'Clipboard access is blocked. Copy this link manually: {url}',
      publishError: 'We could not refresh your public collection. Try again in a moment.',
      nothingToShare: 'Add at least one toy before sharing your collection.',
      publishing: 'Updating link…'
    },
    export: {
      title: 'Export Your Collection',
      subtitle: 'Download a backup of your toys for reports, inventory, or migration.',
      authRequired: 'You need to be signed in to export your collection.',
      loadError: 'We could not load your collection for export. Please try again.',
      empty: 'No toys to export yet. Add items to your collection first.',
      actionsTitle: 'Download files',
      actionsSubtitle: '{count, plural, one {1 item ready} other {{count} items ready}}',
      downloadCsv: 'Download CSV',
      downloadJson: 'Download JSON',
      fileHint: 'CSV works best in spreadsheets. JSON keeps all fields for data migration.',
      previewTitle: 'Preview (first {count} items)',
      previewSubtitle: '{total} total items · Prices in {currency}',
      previewFooter: '{remaining} more items not shown in preview.',
      headers: {
        name: 'Name',
        brand: 'Brand',
        series: 'Series',
        type: 'Type',
        scale: 'Scale',
        code: 'Code',
        quantity: 'Quantity',
        price: 'Price',
        priceCurrency: 'Price Currency',
        preorderPrice: 'Preorder Price',
        preorderPriceCurrency: 'Preorder Currency',
        source: 'Source',
        note: 'Notes',
        createdDate: 'Created Date'
      }
    }
  },

  // Toy Detail
  toyDetail: {
    newToy: '新しいおもちゃを追加',
    editToy: 'おもちゃを編集',
    name: '名前',
    code: 'コード',
    codePlaceholder: 'オプションの商品コード',
    brand: 'ブランド',
    series: 'シリーズ',
    type: 'タイプ',
    scale: 'スケール',
    price: '価格',
    preorderPrice: '予約価格',
    quantity: '数量',
    source: 'ソース',
    imageUrl: '画像URL',
    createdDate: '作成日',
    notes: 'メモ',
    save: 'おもちゃを保存',
    cancel: 'キャンセル',
    delete: 'おもちゃを削除',
    deleteConfirm: 'このおもちゃを削除してもよろしいですか？',
    deleteConfirmDescription: 'この操作は元に戻せません。',
    imagePlaceholder: '画像なし'
  },

  // Insights
  insights: {
    title: 'コレクションインサイト',
    subtitle: 'おもちゃコレクションに関する詳細な分析とインサイト',
    overview: {
      title: '概要',
      collectionStatus: 'コレクション状況',
      ownedItems: '所有アイテム',
      preorderItems: '予約注文アイテム',
      valueBreakdown: '価値の内訳',
      ownedValue: '所有価値',
      preorderValue: '予約価値',
      mostValuableItems: '最も価値の高いアイテム'
    },
    categories: {
      title: 'カテゴリ',
      topBrands: '人気ブランド',
      topSeries: '人気シリーズ',
      topTypes: '人気タイプ',
      topScales: '人気スケール',
      topSources: '人気ソース'
    },
    preorders: {
      title: '予約注文',
      preorderSummary: '予約注文概要',
      items: 'アイテム',
      totalValue: '総価値'
    },
    recent: {
      title: '最近',
      recentAdditions: '最近追加されたアイテム'
    },
    stats: {
      totalItems: '総アイテム数',
      totalValue: '総価値',
      totalQuantity: '総数量',
      averagePrice: '平均価格'
    }
  },

  // Settings
  settings: {
    title: 'ユーザー設定',
    currency: '通貨',
    language: '言語',
    saveSettings: '設定を保存',
    settingsSaved: '設定が正常に保存されました！',
    settingsError: '設定の保存に失敗しました',
    currencyDescription: 'アプリケーション全体で価格を表示するための希望する通貨を設定してください。すべての価格は選択した通貨に変換されます。',
    languageDescription: 'アプリケーションインターフェースの希望する言語を選択してください。言語は即座に適用されます。',
    preferences: '設定'
  },

  // Custom Data
  customData: {
    addNew: '新しい{type}を追加',
    add: '追加',
    adding: '追加中...',
    valueRequired: '値が必要です',
    userNotAuthenticated: 'ユーザーが認証されていません',
    addError: 'カスタムデータの追加に失敗しました',
    description: 'この{type}はあなたの個人リストに追加され、あなたにのみ表示されます。',
    enterValue: '{type}名を入力',
    tip: '{type}が見つからない場合？入力して選択するか、タブアウトすると個人リストに追加されます。',
    standard: '標準',
    manageTitle: 'カスタムデータ管理',
    manageDescription: 'あなたの個人ブランド、シリーズ、タイプ、スケール、ソースエントリを管理します。これらはあなたにのみ表示されます。',
    manageSubtitle: '個人マスターデータ',
    manageSubDescription: '標準リストにない独自のブランド、シリーズ、タイプ、スケール、ソースエントリを追加・管理します。',
    manageButton: 'カスタムデータ管理',
    loadError: 'カスタムデータの読み込みに失敗しました',
    deleteError: 'カスタムデータの削除に失敗しました',
    delete: '削除',
    items: 'アイテム',
    noItems: 'カスタム{type}アイテムはまだありません。',
    customItem: 'カスタムアイテム'
  },

  // Auth
  auth: {
    login: {
      title: 'ToyPortにサインイン',
      email: 'メール',
      password: 'パスワード',
      signIn: 'サインイン',
      signInWithGoogle: 'Googleでサインイン',
      noAccount: 'アカウントをお持ちでない場合',
      signUp: 'サインアップ',
      forgotPassword: 'パスワードを忘れた場合',
      loginError: 'ログインに失敗しました'
    },
    signup: {
      title: 'アカウントを作成',
      displayName: '表示名',
      email: 'メール',
      password: 'パスワード',
      confirmPassword: 'パスワード確認',
      signUp: 'サインアップ',
      signUpWithGoogle: 'Googleでサインアップ',
      haveAccount: 'すでにアカウントをお持ちの場合',
      signIn: 'サインイン',
      signupError: 'アカウントの作成に失敗しました',
      passwordMismatch: 'パスワードが一致しません'
    }
  },

  // Languages
  languages: {
    en: 'English',
    th: 'ไทย',
    ja: '日本語',
    zh: '中文'
  },

  // Wishlist
  wishlist: {
    title: 'ウィッシュリスト',
    subtitle: 'コレクションに追加したいアイテムを追跡',
    addNewWish: 'ウィッシュアイテムを追加',
    addFirstWish: '最初のウィッシュアイテムを追加',
    searchPlaceholder: 'ウィッシュリストアイテムを検索...',
    noWishItems: 'ウィッシュリストにアイテムがありません。',
    noSearchResults: '検索に一致するウィッシュリストアイテムが見つかりません。',
    showingResults: '{total}件中{count}件を表示',
    convertToToy: 'おもちゃに変換',
    convert: 'はい、手に入れました！',
    converting: '変換中...',
    convertConfirm: '手に入れましたか？',
    convertConfirmDescription: 'このアイテムをウィッシュリストからコレクションに移動します。その後、数量とソース情報を追加できます。',
    deleteConfirm: 'ウィッシュアイテムを削除しますか？',
    deleteConfirmDescription: 'このウィッシュアイテムを完全に削除します。この操作は元に戻せません。',
    // New celebratory conversion messages
    congratulations: '🎉 おめでとうございます！🎉',
    finallyGotIt: 'ついに手に入れましたね！',
    thatsAwesome: '素晴らしいです！🎊 この美しいアイテムをウィッシュリストからコレクションに移動する時が来ました。数量や入手先などの詳細を追加できます。',
    readyToCelebrate: 'コレクションへの追加を祝う準備はできましたか？',
    maybeLater: 'また後で',
    yesAddToCollection: '🎉 はい、コレクションに追加！',
    addingToCollection: 'コレクションに追加中...'
  },

  publicCollection: {
    title: 'Shared Collection',
    subtitle: 'Curated by collector {collectorId}',
    backToLanding: 'Back to ToyPort',
    viewOnlyNotice: 'This page is read-only. Prices shown in {currency}.',
    emptyTitle: 'No items to show yet',
    emptyDescription: 'The owner has not added any items or keeps them private.',
    invalidLink: 'This public collection link is invalid.',
    loadError: 'We could not load this collection right now. Please try again later.',
    notShared: 'This collector has not published a public snapshot yet.',
    untitledToy: 'Untitled Toy',
    unknownBrand: 'Unknown brand'
  },

  // Currencies
  currencies: {
    USD: '米ドル',
    THB: 'タイバーツ',
    JPY: '日本円',
    CNY: '中国人民元'
  }
}; 
